export const notFoundValue: string = 'notFound';
export const notInstallBaseRelated: string = 'notInstallBaseRelated';
